import { render } from "./TransferEmployee.vue?vue&type=template&id=39422759&scoped=true"
import script from "./TransferEmployee.vue?vue&type=script&lang=js"
export * from "./TransferEmployee.vue?vue&type=script&lang=js"

import "./TransferEmployee.vue?vue&type=style&index=0&id=39422759&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39422759"]])

export default __exports__